import { ArrowDownThin12 } from '@honeybook/icons';
import styled from 'styled-components';
import HBText from '../../HBText/HBText';
import colors from '../../../styles/colors';
import { ISideNavTheme } from '../context/useCreateTheme';
import { vars } from '../../../theme';

export const ChevronIcon = styled(ArrowDownThin12)<{ isOpen: boolean }>`
    transform: ${({ isOpen }) => (isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
    transition: 200ms cubic-bezier(0.77, 0, 0.175, 1);
`;

export const StyledMenuItem = styled.div<{
    $theme: ISideNavTheme;
    $preventPointerEvents?: boolean;
    isSelected: boolean;
    isOpen: boolean;
    isMinimized: boolean;
}>`
    // Base color for label and icons
    &,
    &:active,
    &:focus {
        color: ${({ $theme, isSelected }) =>
            isSelected ? $theme.activeItemTextColor : $theme.itemTextColor};

        & > div > ${ChevronIcon} svg * {
            fill: ${({ $theme, isSelected }) =>
                isSelected ? $theme.activeItemTextColor : $theme.itemTextColor};
        }
    }

    // Hover color for label and icons
    &&:hover,
    &&:focus-visible {
        color: ${({ $theme }) => $theme.itemTextColorHover};
        i svg * {
            fill: ${({ $theme }) => $theme.itemTextColorHover};
        }
    }

    ${({ $theme, isSelected, isOpen }) =>
        isSelected &&
        !isOpen &&
        `
    color: ${$theme.activeItemTextColor};
    svg * {
        fill: ${$theme.activeItemTextColor};
    }
    `}

    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 9px 14px;
    border-radius: ${vars.radius.xs};
    text-decoration: none;
    cursor: pointer;
    user-select: none;
    ${({ $theme, isSelected, isOpen, isMinimized }) => {
        if (isMinimized) {
            return isSelected
                ? `background-color: ${$theme.activeItemBackgroundColor};
                svg * {
                    fill: ${$theme.activeItemTextColor};
                }
                `
                : 'background-color: transparent';
        }
        if (isSelected && !isOpen) {
            return `background-color: ${$theme.activeItemBackgroundColor};
                svg * {
                    fill: ${$theme.activeItemTextColor};
                }
                `;
        }
        return 'background-color: transparent';
    }};
    &:hover {
        background-color: ${({ $theme, isOpen, isSelected }) =>
            isOpen
                ? 'transparent'
                : isSelected
                ? $theme.activeItemBackgroundColorHover
                : $theme.itemBackgroundColorHover};
    }
    &:active {
        background-color: ${({ isSelected, $theme }) =>
            isSelected
                ? $theme.activeItemBackgroundColorActive
                : $theme.itemBackgroundColorActive};
    }
    &:focus-visible {
        outline: 2px solid ${colors.blue20};
        outline-offset: -2px;
    }
    transition: background-color 200ms cubic-bezier(0.77, 0, 0.175, 1);
    pointer-events: ${({ $preventPointerEvents }) =>
        $preventPointerEvents ? 'none' : 'auto'};
`;

export const StyledLabelContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`;

export const StyledLabel = styled.span<{
    hideLabel: boolean;
}>`
    white-space: nowrap;
    display: flex;
    align-items: center;
    flex: 1;
    gap: 6px;
    opacity: 1;
    ${({ hideLabel }) => hideLabel && 'opacity: 0'};
    transition: opacity cubic-bezier(0.77, 0, 0.175, 1);
`;

export const StyledDescription = styled(HBText)`
    padding-left: 24px;
`;
